import React from 'react';
import { Skeleton } from '@mui/material';
import { StyledCardSkeleton } from './index.style';

const CardSkeleton = () => (
  <StyledCardSkeleton>
    <Skeleton variant="rounded" className="skeleton-thumbnail" />
    <div className="skeleton-info">
      <Skeleton variant="text" width="70%" />
      <Skeleton variant="text" width="35%" />
    </div>
  </StyledCardSkeleton>
);

export default CardSkeleton;
